import React, { useEffect }  from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import ImportantAnnouncementBoard from "../components/ImportantAnnouncementBoard";
import AnnouncementBoard from "../components/AnnouncementBoard";
import QuickAccessCard from "./components/QuickAccessCard";
import StaffStatusMonitoringList from "./components/StaffStatusMonitoringList";
import DashboardSummaryCard from "./components/DashboardSummaryCard";
import AttendanceTrend from "./components/AttendanceTrend";
import PayrollOverview from "./components/PayrollOverview";
import HyvidAwardWinner from "./components/HyvidAwardWinner";
import ClientReferral from "./components/ClientReferral";
import ActionRequiredBoard from "./components/ActionRequiredBoard";
import { actions } from './components/actions'

const ClientDashBoard = () => {

    const user = useSelector((state) => state.auth);
    const loading = useSelector((state) => state.auth.loading);
    const error = useSelector((state) => state.auth.error);

    const location = useLocation();

    const showActionRequired =
      location.hash === "#action-required";
    const leaveRequests = actions.filter(a => a.category === "Leave Requests");
    const leaveCount = leaveRequests.length;
    const overdue = actions.filter(a => a.category === "Overdue - Urgent");
    const overdueCount = overdue.length;
    const dueSoon = actions.filter(a => a.category === "Due Soon");
    const dueSoonCount = dueSoon.length;
    const tasks = actions.filter(a => a.category === "Tasks");
    const tasksCount = tasks.length;

    useEffect(() => {
      const el = document.getElementById("app-scroll");
      if (el) {
        el.scrollTo({ top: 0, behavior: "instant" });
      } else {
        window.scrollTo(0, 0);
      }
    }, [location.hash]);

    return (
        <div className="space-y-6">
          {!showActionRequired ? (
            <>
              <ImportantAnnouncementBoard />
              {/* <AnnouncementBoard /> */}
              <QuickAccessCard />
              <StaffStatusMonitoringList />
              <DashboardSummaryCard />
              <AttendanceTrend />
              <PayrollOverview />
              <HyvidAwardWinner />
              <ClientReferral />
            </>
          ) : (
            <ActionRequiredBoard 
              leaveCount={leaveCount}
              overdueCount={overdueCount} 
              dueSoonCount={dueSoonCount}
              tasksCount={tasksCount}
            />
          )}
        </div>
    )
};

export default ClientDashBoard;